import { useEffect } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

export const useSyncIsFlippingPosition = (
	tradeFormSide: 'buy' | 'sell',
	currentPositionDirection: 'long' | 'short',
	currentPositionIsZero: boolean
) => {
	const setState = useVelocityStore((s) => s.set);

	useEffect(() => {
		if (currentPositionIsZero) {
			setState((s) => {
				s.tradeForm.isFlippingPosition = false;
			});
		} else {
			const isFlippingPosition =
				(currentPositionDirection === 'short' && tradeFormSide === 'buy') ||
				(currentPositionDirection === 'long' && tradeFormSide === 'sell');

			setState((s) => {
				s.tradeForm.isFlippingPosition = isFlippingPosition;
			});
		}
	}, [tradeFormSide, currentPositionDirection, currentPositionIsZero]);
};
